import { Typography } from '@material-ui/core';
import { ORANGE } from 'theme/palette';

interface CognitiveMatchScoreProps {
  score: number | null | undefined;
  fontSize?: number;
  marginLeft?: string;
  alignSelf?: string;
  t: (key: string) => string;
}

const CognitiveMatchScore = ({
  score,
  fontSize = 14,
  marginLeft = '0px',
  alignSelf = 'flex-start',
  t
}: CognitiveMatchScoreProps) => {
  if (score === null || score === undefined || score < 0) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      color={ORANGE[500]}
      style={{
        fontFamily: 'Rubik',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: `${fontSize}px`,
        marginLeft,
        alignSelf
      }}
    >
      {`${score}% ${t('Cognitive Match')}`}
    </Typography>
  );
};

export default CognitiveMatchScore;

